export const newPhaseItemModalStyles = {
  modal: (isActivityFeedVisible: boolean) => ({
    '& .MuiDialogActions-root': {
      justifyContent: 'center',
      height: '48px',
      padding: 0,
      '& button': {
        margin: '0 12px',
      },
    },

    '& .MuiDialog-paper': {
      padding: isActivityFeedVisible ? '0' : '0 8px',
      width: isActivityFeedVisible ? '1100px' : '650px',
      maxWidth: isActivityFeedVisible ? '1100px' : '650px',
      borderRadius: '12px',
      overflow: 'hidden',
      backgroundColor: '#fff',
    },
  }),

  header: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    padding: '0 0 20px 0',
    borderBottom: '1px solid #F3F4F9',
  },

  titleContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },

  title: {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '24px',
    lineHeight: '136%',
    color: '#23252F',
    marginBottom: '4px',
  },

  subtitle: {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '146%',
    color: '#6E707A',
  },

  tabsContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: '32px',
    padding: '20px 0 24px 0',

    '& a': {
      border: '1px solid #F3F4F9',
    },
  },

  tabsContainerEdit: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: '16px',
    padding: '0 0 20px 0',

    '& a': {
      border: '1px solid #F3F4F9',
    },
  },

  tabList: {
    border: '1px solid #F3F4F9',
    borderRadius: '8px',

    minHeight: 'unset',
    '& .MuiTabs-indicator': {
      display: 'none',
    },
    '& a': {
      border: '1px solid #F3F4F9',
    },
    '& a:nth-of-type(1)': {
      borderRight: 'none',
      borderTopLeftRadius: '8px',
      borderBottomLeftRadius: '8px',
    },
    '& a:nth-last-of-type(1)': {
      borderLeft: 'none',
      borderTopRightRadius: '8px',
      borderBottomRightRadius: '8px',
    },
    '& .Mui-selected': {
      backgroundColor: '#E7ECFF',
      border: '1px solid #E7ECFF',
      color: '#4D6EF5',
    },
  },

  tab: {
    minHeight: 'unset',
    padding: '8px 16px',
    fontSize: '12px',
    lineHeight: '150%',
    color: '#6E707A',
    textTransform: 'capitalize',
    minWidth: 'unset',
  },

  detailsTab: {
    minWidth: '188px',
    width: '188px',
    minHeight: 'unset',
    padding: '8px 0',
    fontSize: '12px',
    lineHeight: '150%',
    color: 'green',
    textTransform: 'capitalize',
  },

  tabWrapper: {
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
    maxHeight: '45vh',

    '&::-webkit-scrollbar': {
      border: 'none',
      width: '11px',
      height: '11px',
    },

    '&::-webkit-scrollbar-track': {
      backgroundColor: '#fff',
      border: 'none',
      height: '10px',
    },

    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#D4D6E0',
      width: '2px',
      borderRadius: '6px',
      cursor: 'pointer',
    },
  },

  tabPanel: {
    padding: '10px',
  },

  buttonsWrapper: {
    width: '100%',
    padding: '20px 0 0 0',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '12px',
  },

  buttonsContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: '12px',
  },

  deleteButton: {
    color: '#D12D36',
    border: '1px solid #D12D36',
    transition: '300ms',
  },

  cancelButton: {
    width: '70px',
    background: '#FFFFFF',
    borderRadius: '8px',
    border: '1px solid #4D6EF5',
    padding: '14px 12px',
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '146%',
    display: 'flex',
    alignItems: 'center',
    textAlign: 'center',
    color: '#4D6EF5',
    transition: '300ms',
    textTransform: 'none',

    '&:hover': {
      color: '#FFFFFF',
      background: '#4D6EF5',
      border: '1px solid #4D6EF5',
      boxShadow:
        '0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%)',
    },
  },

  saveButton: {
    background: '#4D6EF5',
    borderRadius: '8px',
    border: '1px solid #4D6EF5',
    padding: '14px 18px',
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '146%',
    display: 'flex',
    alignItems: 'center',
    textAlign: 'center',
    color: '#FFFFFF',
    transition: '300ms',
    textTransform: 'none',

    '&:hover': { color: '#4D6EF5', background: '#FFFFFF', border: '1px solid #4D6EF5' },
  },

  form: {
    padding: '40px 10px 20px 32px',
  },
};
